import { render, staticRenderFns } from "./PreOrderTripDetail.vue?vue&type=template&id=8e629312&"
import script from "./PreOrderTripDetail.vue?vue&type=script&lang=js&"
export * from "./PreOrderTripDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports